var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text center"},[_c('p',[_c('VueTextGlitch',{attrs:{"fill":"#fefefe","background":"#1d1d1d","text":"distort_ space"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }